import { forwardRef, useEffect } from "react";
import Cross from "../../assets/svgs/Close.svg";

const AdvanceRightModal = forwardRef(
  (
    {
      isOpen,
      onClose,
      children,
      title,
      desc,
      onFilter,
      onClearAll, // ✅ Add this prop
    },
    ref
  ) => {

    const handleClose = () => {
      onClose();
    };

    useEffect(() => {
      if (!isOpen) return;

      const handleClickOutside = (e) => {
        if (!ref?.current) return;

        if (
          e.target.closest(".react-select__menu") ||
          e.target.closest(".react-select__control")
        ) {
          return;
        }

        if (!ref.current.contains(e.target)) {
          handleClose();
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen, ref]);

    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-gray-700 bg-opacity-50 z-[9990]">
        <div
          ref={ref}
          className="user-profile open fixed right-0 top-0 h-full bg-white z-[9999]"
        >
          {/* HEADER */}
          <div className="p-6">
            <div className="flex items-center justify-between">
              <p className="head-2 dark-H">{title}</p>
              <img
                role="button"
                src={Cross}
                alt="close"
                onClick={handleClose}
              />
            </div>

            {desc && (
              <div className="mt-2">
                <p className="dark-M body-S">{desc}</p>
              </div>
            )}

            <hr className="mt-6 border-[#6F6F6F]" />
          </div>

          {/* BODY */}
          <div className="profile-body px-6 overflow-y-auto pb-12">
            {children}
          </div>

          {/* FOOTER */}
          <div className="light-bg-L filter-button p-6">
            <hr className="mb-6 border-[#6F6F6F]" />
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <button
                  type="button"
                  className="save-button light-L head-5 green-bg-H"
                  onClick={onFilter}
                >
                  Filter
                </button>

                <button
                  type="button"
                  onClick={handleClose}
                  className="green-H head-5"
                >
                  Cancel
                </button>
              </div>

              {/* ✅ Clear All button */}
              {onClearAll && (
                <button
                  type="button"
                  onClick={onClearAll}
                  className="text-red-500 head-5"
                >
                  Clear All
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default AdvanceRightModal;